import StoreStatusContainer from './StoreStatusContainer';
export default StoreStatusContainer;
